/*
 * Capitalize first letter of string
 */
export const capitalize = (s: string) => s.replace(/^./, s[0].toUpperCase());
